import { atom } from 'recoil';

interface FiltersState {
	collection: string | null;
	sort: string | null;
	pagination: number;
}

export const marketplaceFiltersState = atom<FiltersState>({
	key: 'marketplaceFiltersState',
	default: {
		collection: null,
		sort: null,
		pagination: 1
	}
});

export const myCollectionFiltersState = atom<string | null>({
	key: 'myCollectionFiltersState',
	default: null
});
